module.exports = __webpack_public_path__ + "img/pattern_03.e8fc9e4d.jpg";